<div
  class="FlightStatusAlert-containerAlert fw-medium-x lh-34px"
  [ngClass]="alertClass"
>
  <img alt="" class="FlightStatusAlert-iconGreen" src="../../../../../assets/images/circleGreen.svg" *ngIf="(typeAlert == typeIrops.SCHEDULED || typeAlert == typeIrops.ON_TIME)"/>
  <div *ngIf="typeAlert == typeIrops.CANCELLED">
    {{ "srIrops.cancelledFlightR" | translate }}
  </div>
  <div *ngIf="typeAlert == typeIrops.DELAYED" class="delayed">
    {{ "srIrops.delayedTime" | translate }}
    <span *ngIf="timeDif?.hours > 0">
      {{ "srIrops.hour" | translate:{ hour: timeDif?.hours } }} </span>
    <span *ngIf="timeDif?.minutes > 0">{{ "srIrops.min" | translate:{ min: timeDif?.minutes } }}</span>
  </div>
  <div *ngIf="typeAlert == typeIrops.EARLY">
    {{ "srIrops.earlyTime" | translate }}
    <span *ngIf="timeDif?.hours > 0">{{ "srIrops.hour" | translate:{ hour: timeDif?.hours } }} </span>
    <span *ngIf="timeDif?.minutes > 0">{{ "srIrops.min" | translate:{ min: timeDif?.minutes } }}</span>
  </div>
  <div *ngIf="(typeAlert == typeIrops.SCHEDULED || typeAlert == typeIrops.ON_TIME)">
    {{ "flightStatus.on_time" | translate }}
  </div>
</div>
